var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.4 200.4",
    enableBackground: "new 0 0 200.4 200.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#45CDAA",
    cx: 100.2,
    cy: 100.2,
    r: 95.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M139.4,125l-9-20.5c-0.2-0.4-0.4-0.7-0.6-1v-8.1c0-12.6-8.5-23.7-20.6-27v-1.1c0.2-5.1-3.8-9.3-8.9-9.5 c-5.1-0.2-9.3,3.8-9.5,8.9c0,0.2,0,0.4,0,0.6V69C79.6,72.9,72,83.5,72,95.5v7.8c-0.3,0.3-0.5,0.6-0.7,1L61,124.7 c-1.1,2.3-0.2,5,2.1,6.1c0.6,0.3,1.4,0.5,2.1,0.5h70c2.5,0,4.5-2,4.6-4.5C139.8,126.2,139.7,125.6,139.4,125z M101.8,67.4H100 c-1.9,0-3.8,0.2-5.7,0.6l0,0c0-2.9,2-5.4,4.9-5.8c3.1-0.5,6,1.7,6.5,4.9c0,0.3,0.1,0.5,0.1,0.8C104.4,67.5,103.1,67.4,101.8,67.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M110.6,135.3c-0.2,5.7-5,10.3-10.7,10.1c-5.5-0.2-9.9-4.6-10.1-10.1c0-0.2,0-0.4,0-0.7h20.7 C110.6,134.9,110.6,135.1,110.6,135.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell3);
export default __webpack_public_path__ + "static/media/bell3.4edce844.svg";
export { ForwardRef as ReactComponent };